export default {
  name: 'service-catalog',
  translationKey: 'service-catalog-module',
  routePrefix: 'service-catalog',
  routeNamePrefix: 'service-catalog',
  directRoutesAvailable: true,
}
